import { useDebounce } from 'react-use';
import { Box } from '@mui/material';
import { Formik, useFormikContext } from 'formik';

import {
  AssignStationStep,
  ConfirmVenueStep,
  CreateVenueStep,
  PlacementDetailReviewStep,
  ReviewAndConfirmStep,
  StartAndFindVenueStep,
  VenueDetailReviewStep,
} from '~components/organisms/pinning';
import {
  LOCAL_FORM_VALUES,
  useVenuePlacementCreationContext,
} from '~providers';
import {
  PINNING_STEP,
  usePinningStepContext,
} from '~providers/PinningStepProvider';
import {
  type IFormCreationValues,
  useFormCreateContext,
} from '~providers/useForm';

export const HomePage: React.FC = () => {
  const { initialValues, formResetKey, handleSubmit, validationSchema } =
    useFormCreateContext();

  return (
    <Formik
      key={formResetKey}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      <HomePageView />
    </Formik>
  );
};

const HomePageView: React.FC = () => {
  const { pinningStep, progress } = usePinningStepContext();
  const { selectedPlacement } = useVenuePlacementCreationContext();
  const { values } = useFormikContext<IFormCreationValues>();

  useDebounce(
    () => {
      if (pinningStep !== PINNING_STEP.START)
        localStorage.setItem(
          LOCAL_FORM_VALUES,
          JSON.stringify(values), // Save form values to localStorage whenever they change
        );
    },
    500, // 500ms delay debounce to improve performace
    [values],
  );
  return (
    <>
      {progress && (
        <Box
          width="100%"
          height={'4px'}
          bgcolor={'#EBFBFF'}
          flexShrink={0}
          sx={{ position: 'sticky', top: 0, zIndex: 3 }}
        >
          <Box
            width={progress}
            height={'100%'}
            bgcolor={'primary.main'}
            borderRadius={2}
          />
        </Box>
      )}
      {(pinningStep === PINNING_STEP.START ||
        pinningStep === PINNING_STEP.FIND_VENUE) && <StartAndFindVenueStep />}
      {pinningStep.includes('CREATE_VENUE') && <CreateVenueStep />}
      {(pinningStep.includes('ASSIGN_STATION') ||
        pinningStep === PINNING_STEP.CONFIRM_SWAP_STATION ||
        pinningStep === PINNING_STEP.CONFIRM_RELOCATION) && (
        <AssignStationStep />
      )}
      {pinningStep === PINNING_STEP.CONFIRM_VENUE && <ConfirmVenueStep />}
      {pinningStep === PINNING_STEP.REVIEW_CONFIRM && <ReviewAndConfirmStep />}
      {pinningStep === PINNING_STEP.VENUE_DETAIL_REVIEW && (
        <VenueDetailReviewStep />
      )}
      {pinningStep === PINNING_STEP.PLACEMENT_DETAIL_REVIEW && (
        <PlacementDetailReviewStep index={selectedPlacement} />
      )}
    </>
  );
};
